import React from 'react';
import './hotel.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import { Container, Col, Row } from 'react-bootstrap';
import TravelPartner from '../../components/travel_partner';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import FAQTabs from '../../components/Accordion';
import BottomSignupGradient from '../../components/bottom_signup_gradient';
import { CustomTypoH1 } from '../../helper/headings';

// SVGs Desktop Version
import HotelSVG1 from '../../assets/hotel/hotel_1.svg';
import HotelSVG2 from '../../assets/hotel/hotel_2.svg';
import HotelSVG3 from '../../assets/hotel/hotel_3.svg';
import HotelSVG4 from '../../assets/hotel/hotel_4.svg';
// SVGs Mobile Version
import HotelSVGMOB1 from '../../assets/hotel/mobile/hotel_mob1.svg';
import HotelSVGMOB2 from '../../assets/hotel/mobile/hotel_mob2.svg';
import HotelSVGMOB3 from '../../assets/hotel/mobile/hotel_mob3.svg';
import HotelSVGMOB4 from '../../assets/hotel/mobile/hotel_mob4.svg';
import AppNavBar from '../../helper/appbar';

const Hotel = () => {
  const freeSignUp = () => window.open("http://app.gokardinal.com/onboarding", "_blank");
  return (
    <div className='hotel_main'>
      <AppNavBar navType={'dark'} />
      <Container fluid >
        <Row className="hotel-head-section" >
          <Col xl={6} lg={6} md={6} sm={12} xs={12} className="hotel-head-section-text">
            <h1>The Right Room In Over 800 Destinations</h1>
            <p>Book accommodation anywhere in the world, easily.</p>
            <button className='hotel-filled-btn' onClick={freeSignUp}>
              Sign up for free
              <ChevronRightIcon className='hotel-chev-right-filled' />
            </button>
          </Col>
          <Col xl={6} lg={6} md={6} sm={12} xs={12} className="hotel-head-section-image">
            <img src={HotelSVG1} alt="girl" loading='lazy' className='svg__desktop' />
            <img src={HotelSVGMOB1} alt="girl" loading='lazy' className='svg__mobile' />
          </Col>
        </Row>
        <Row className='hotel_section1'>
          <Col xs={{ span: 12, order: 2 }} sm={{ span: 12, order: 2 }} md={{ span: 6, order: 1 }} lg={{ span: 6, order: 1 }} xl={{ span: 6, order: 1 }} className="hotel-section1-image">
            <img src={HotelSVG2} alt="hall" loading='lazy' className='svg__desktop' />
            <img src={HotelSVGMOB2} alt="girl" loading='lazy' className='svg__mobile' />
          </Col>
          <Col xs={{ span: 12, order: 1 }} sm={{ span: 12, order: 1 }} md={{ span: 6, order: 2 }} lg={{ span: 6, order: 2 }} xl={{ span: 6, order: 2 }} className="hotel-section1-text">
            <h1>
              Personalized solution for business accommodation
            </h1>
            <p>
              Find the right reservation (short stays, long stays, etc.) without compromising your expectations. Our platform offer hotels that comply with your policies as well as your preferences.
            </p>
          </Col>
        </Row>
        <Row className="hotel-section2">
          <Col xs={{ span: 12, order: 2 }} sm={{ span: 12, order: 2 }} md={{ span: 6, order: 1 }} lg={{ span: 6, order: 1 }} xl={{ span: 6, order: 1 }} className="hotel-section2-text">
            <h1>
              Best proven rates for your stay.
            </h1>
            <p>We go into long term contracts with top hotels in the market and load them in our loyalty programs to drive cost savings.</p>
            <p> Explore the comfort of our hotels when you sign up. </p>
          </Col>
          <Col xs={{ span: 12, order: 2 }} sm={{ span: 12, order: 2 }} md={{ span: 6, order: 1 }} lg={{ span: 6, order: 1 }} xl={{ span: 6, order: 1 }} className="hotel-section2-image">
            <div>
              <img src={HotelSVG3} alt="man" loading='lazy' className='svg__desktop' />
              <img src={HotelSVGMOB3} alt="girl" loading='lazy' className='svg__mobile' />
            </div>
          </Col>
        </Row>
        <Row className='hotel-section3'>
          <Col xs={{ span: 12, order: 2 }} sm={{ span: 12, order: 2 }} md={{ span: 6, order: 1 }} lg={{ span: 6, order: 1 }} xl={{ span: 6, order: 1 }} className="section3-image">
            <div>
              <img src={HotelSVG4} alt="list" loading='lazy' className='svg__desktop' />
              <img src={HotelSVGMOB4} alt="girl" loading='lazy' className='svg__mobile' />
            </div>
          </Col>
          <Col xs={{ span: 12, order: 1 }} sm={{ span: 12, order: 1 }} md={{ span: 6, order: 2 }} lg={{ span: 6, order: 2 }} xl={{ span: 6, order: 2 }} className="hotel-section3-text">
            <h1>
              Group Accommodation?
            </h1>
            <p>
              Our tailored accommodation program offers an integrated end-to-end solution for group reservations with a seamless on-demand pick-up/drop-off professional chauffeur experience.</p>
          </Col>
        </Row>
      </Container>

      <section className='s_hotel_section6 hotel_faq_mobile_section'>
        <CustomTypoH1 typo={`Your concerns, answered.`} />
        <FAQTabs activeKey={1} />
      </section>

      <TravelPartner />

      <BottomSignupGradient
        type={`Explore the comfort of our hotels.`}
      />

      {/* Section 5th */}
      <section className='s_hotel_section6 hotel_faq_desktop_section'>
        <CustomTypoH1 typo={`Your concerns, answered.`} />
        <FAQTabs activeKey={1} />
      </section>
    </div >

  );
};

export default Hotel;